import React from 'react';
import { Col, Input, Row, Switch, Form } from 'antd';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import TextArea from 'antd/lib/input/TextArea';

const Hypotheque = () => {
  return (
    <div style={{ backgroundColor: '#ffff', padding: 5 }}>
      <Form
        layout="vertical"
        initialValues={{
          assettype: 'Maison', // Example value for asset type
          proprtyassetflag: true, // Switch is turned on
          lotreference: '12345-AB', // Example lot reference
          assetstatus: 'Disponible', // Example asset status
        }}
      >
        <div style={{ padding: 5, background: 'white' }}>
          <div>
            <Row gutter={20}>
              {/* First Column */}
              <Col span={6}>
                <FormInput name="assettype">
                  <ParListSelect parcode="ASSTYPEG" />
                </FormInput>

                <FormInput name="proprtyassetflag">
                  <Switch />
                </FormInput>
              </Col>

              {/* Second Column */}
              <Col span={6}>
                <FormInput name="lotreference">
                  <Input />
                </FormInput>

                <FormInput name="assetstatus">
                  <ParListSelect parcode="GUARSTAT" />
                </FormInput>
              </Col>

              {/* Third Column */}
              <Col span={10}>
                <FormInput name="guardescription">
                  <TextArea rows={5} />
                </FormInput>
              </Col>
            </Row>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default Hypotheque;